// Who we legally are.
//
// Taken from the trade licence issued by the Dubai Integrated Economic Zones
// Authority. One place, because these strings belong in the footer, the legal
// page and anything regulator-facing — and a licence number that disagrees with
// itself across a site is worse than one that is absent.
//
// NOTE ON THE LICENSED ACTIVITIES. They are software design, software trading
// (i.e. selling software) and IT consultancy. They are NOT financial services,
// investment advice, asset management or brokerage. That constrains what the
// site may claim: we sell tools that execute the user's own instructions on the
// user's own broker account. The disclaimer below is not decoration.
export const COMPANY = {
  legalName: "TRUBON TECHNOLOGIES - FZCO",
  shortName: "Kairosis Capital",
  legalStatus: "FZCO",
  licenceNumber: "91631",
  issuingAuthority: "Dubai Integrated Economic Zones Authority",
  address: {
    premises: "DSO-IFZA",
    building: "IFZA Properties",
    area: "Dubai Silicon Oasis",
    city: "Dubai",
    country: "United Arab Emirates",
  },
  activities: [
    "Computer Systems & Communication Equipment Software Design",
    "Computer Systems & Communication Equipment Software Trading",
    "Information Technology Consultants",
  ],
  supportEmail: "kairosis.capital@gmail.com",
  whatsapp: "https://wa.link/og6izz",
};

export const addressLine = () =>
  `${COMPANY.address.premises}, ${COMPANY.address.building}, ${COMPANY.address.area}, ${COMPANY.address.city}, ${COMPANY.address.country}`;

// Says three things on purpose: that this is software rather than advice, that
// the user's own broker holds the money and takes the order, and that leverage
// loses money. The first two keep a software licence the right licence; the
// third is what every jurisdiction expects beside a product that touches a
// trading account.
export const DISCLAIMER =
  "Our products are software tools. We are not a broker, not an investment adviser, and not a money manager. " +
  "They place no order except the ones you configure, on a broker account you own and control. " +
  "Trading leveraged instruments carries a high risk of losing money rapidly. Past performance does not indicate future results. " +
  "Nothing on this site is financial advice.";
